import MonthlyReportPopup from './MonthlyReportPopup';

export default MonthlyReportPopup;
